<template>
  <div class="address-wrap" :class="{ show: showMore }">
    <div class="title-wrap">
      <h2 class="title">
        <span>{{ simple ? '收票地址' : '收货地址' }}：</span>
        <el-button
          type="text"
          v-if="!isEdit"
          class="address-btn"
          icon="el-icon-plus"
          @click="addAddress"
        >
          新增地址
        </el-button>
        <el-button
          type="text"
          v-if="!isEdit"
          class="address-btn"
          v-show="!simple"
          icon="el-icon-s-operation"
          @click="isEdit = !isEdit"
        >
          管理
        </el-button>
        <el-button
          type="text"
          v-else
          v-show="!simple"
          class="address-btn"
          icon="el-icon-close"
          @click="isEdit = !isEdit"
        >
          退出管理
        </el-button>
        <div v-if="simple" class="asAddress">
          <el-switch
            v-model="asAddress"
            active-color="#2A54D1"
            inactive-color="#d0d0d0"
            size="mini"
            style="margin-right: 4px"
          >
          </el-switch
          >同收货地址
        </div>
        <span style="flex: 1"></span>
        <div
          class="show-more"
          v-if="list.length > 4"
          v-show="!asAddress"
          @click="showMore = !showMore"
        >
          <span>{{ !showMore ? '展开更多地址' : '收起更多地址' }}</span>
          <i></i>
        </div>
      </h2>
    </div>
    <div class="address-list" v-show="!asAddress" :class="{ simple: simple }">
      <div
        v-for="(item, index) in showMore ? list : list.slice(0, 4)"
        :key="index"
        class="address-item"
        :class="{ active: item.userAddressId === addressId }"
        @click="selectAddress(item)"
      >
        <div class="area">
          {{ item.province }} {{ item.city }} {{ item.area }}
        </div>
        <div class="address">{{ item.address }}</div>
        <div class="user">
          <span
            >{{ item.receiveGoodsPerson }} {{ item.receiveGoodsPhone }}</span
          >
          <span v-if="item.defaultAddress" class="default">默认</span>
        </div>
        <div class="btns" v-if="isEdit">
          <div>
            <el-checkbox
              class="el-checkbox-radio"
              @change="setDefault(item)"
              :value="item.defaultAddress"
              >默认</el-checkbox
            >
          </div>
          <div class="do-btn">
            <span @click="editAddress(item)" class="edit-btn">编辑</span>
            <span @click="delAddress(item)" class="edit-btn">删除</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="row.userAddressId ? '编辑地址' : '新增地址'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
      <AddAddress v-if="dialogVisible" @success="success" :row="row" />
    </el-dialog>
  </div>
</template>

<script>
import AddAddress from './addAddress.vue'

export default {
  components: {
    AddAddress
  },
  props: {
    companyId: {
      type: String,
      default: ''
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      list: [],
      showMore: false,
      addressId: 0,
      dialogVisible: false,
      row: {},
      isEdit: false,
      asAddress: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.$http
        .get(
          `/front/consumer/user/address/userAddressList?companyId=${this.companyId}`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.list = res.data
            // 获取默认地址 或者第一个
            if (!this.list.length) {
              this.$emit('setAddressId')
              return
            }
            const bool = this.list.some((v) => {
              if (v.defaultAddress) {
                this.addressId = v.userAddressId
              }
              return v.defaultAddress
            })
            if (!bool) {
              this.addressId = this.list[0].userAddressId
            }
            this.$emit('setAddressId', this.addressId)
          }
        })
    },
    addAddress () {
      this.row = {}
      this.dialogVisible = true
    },
    editAddress (v) {
      this.row = v
      this.dialogVisible = true
    },
    setDefault (item) {
      console.log(item)
      const obj = {
        ...item,
        defaultAddress: !item.defaultAddress
      }
      this.$http
        .post('/front/consumer/user/address/updateUserAddress', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.getList()
          }
        })
    },
    delAddress (row) {
      this.$confirm(`确定要删除该地址吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDelAddress(row)
      })
    },
    doDelAddress (row) {
      this.$http
        .post(`/front/consumer/user/address/deleteById/${row.userAddressId}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.getList()
            this.$message.success('删除成功')
          }
        })
    },
    selectAddress (item) {
      this.addressId = item.userAddressId
    },
    success () {
      this.getList()
      this.dialogVisible = false
    },
    getResult () {
      const res = this.list.find((v) => v.userAddressId === this.addressId)
      res.addressId = res.userAddressId
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.address-wrap {
  background: #fff;
  padding: 16px 12px;
  border-radius: 12px;
}

.show {
  .show-more i {
    transform: rotate(180deg);
  }
}

.title {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 0;
  color: #000000;
  .el-button {
    font-size: 12px;
    color: #2a54d1;
  }
  .show-more {
    display: flex;
    align-items: center;
    color: #979799;
    font-size: 12px;
    margin-left: 12px;
    font-weight: normal;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    i {
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url('~@/assets/img/plc/down.png') no-repeat;
      background-size: cover;
      transition: all 0.3s ease;
    }
  }
}

.title-wrap {
  padding: 0 0 16px 28px;
}

.address-list {
  display: flex;
  flex-wrap: wrap;
  transition: all 0.3s ease;

  .address-item {
    position: relative;
    width: 285px;
    color: #3d3d3d;
    border-radius: 8px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid rgba(42, 84, 209, 0.2);
    margin: 0 0 12px 12px;
    padding: 12px 12px 12px 63px;
    cursor: pointer;
    &.active {
      border: 1px solid #2a54d1;
    }
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
    &::before {
      position: absolute;
      left: 15px;
      top: calc(50% - 14px);
      content: '';
      display: block;
      width: 21px;
      height: 28px;
      background: url('~@/assets/img/plc/loc.png') no-repeat center;
      background-size: cover;
    }
  }
  .area {
    font-size: 12px;
    padding-bottom: 4px;
  }
  .address {
    font-size: 16px;
    padding-bottom: 4px;
  }
  .user {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }
}

.default {
  display: inline-block;
  width: 32px;
  height: 17px;
  line-height: 17px;
  border-radius: 4px;
  background: #2a54d1;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  cursor: default;
}

.btns {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;

  .do-btn {
    flex: 1;
    text-align: right;
  }
  .edit-btn {
    display: inline-block;
    width: 40px;
    height: 22px;
    line-height: 20px;
    border-radius: 4px;
    border: 1px solid#ECECF3;
    font-size: 12px;
    background: #ececf3;
    text-align: center;
    color: #3d3d3d;
    margin-left: 8px;
    &:hover {
      border-color: #2a54d1;
      background: #2a54d1;
      color: #ffffff;
    }
  }
}

.address-btn ::v-deep [class*='el-icon-'] + span {
  margin-left: 0;
}

.el-checkbox-radio {
  ::v-deep .el-checkbox__inner {
    border-radius: 50%;
  }

  ::v-deep .el-checkbox__label {
    padding-left: 4px;
  }
}

.asAddress {
  display: flex;
  align-items: center;
  padding-left: 16px;
  font-size: 12px;
  color: #2a54d1;
  font-weight: normal;
}
</style>
